module.exports = __webpack_public_path__ + "static/media/hacker.5be09e27.svg";